import apiClient, { type RequestConfig } from './client'

export interface MatterRule {
  id: string
  matter_id: string
  user_id: string
  subject: string
  predicate: string
  object: string
  negation: boolean
  scope: string
  rationale?: string | null
  target_document_id?: string | null
  created_at: string
  updated_at: string
}

export interface CreateMatterRuleRequest {
  subject: string
  predicate: string
  object: string
  negation?: boolean
  scope?: string
  rationale?: string
  target_document_id?: string
}

export const matterRulesApi = {
  async list(
    matterId: string,
    params?: { scope?: string; own_only?: boolean },
    config?: RequestConfig
  ): Promise<MatterRule[]> {
    const { data } = await apiClient.get<MatterRule[]>(`/matters/${matterId}/rules`, {
      ...config,
      params: params as Record<string, string | number | boolean | undefined> | undefined,
    })
    return data
  },

  async create(
    matterId: string,
    payload: CreateMatterRuleRequest,
    config?: RequestConfig
  ): Promise<MatterRule> {
    const { data } = await apiClient.post<MatterRule>(`/matters/${matterId}/rules`, payload, config)
    return data
  },

  async remove(
    matterId: string,
    ruleId: string,
    config?: RequestConfig
  ): Promise<void> {
    await apiClient.delete(`/matters/${matterId}/rules/${ruleId}`, config)
  },
}
